import { faEarthAfrica, faEarthAmericas, faEarthAsia, faEarthEurope, faEarthOceania } from "@fortawesome/pro-solid-svg-icons";

// Choose the right Earth icon based on timezone
const timezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone || 'Europe/Paris';

export default
    {
        Africa: faEarthAfrica,
        America: faEarthAmericas,
        Asia: faEarthAsia,
        Australia: faEarthOceania,
        Indian: faEarthAsia,
        Pacific: faEarthOceania,
    }[timezone.split('/')[0]] || faEarthEurope;
